import { render, staticRenderFns } from "./margin-line.vue?vue&type=template&id=1c6dfe1a&scoped=true"
import script from "./margin-line.vue?vue&type=script&lang=js"
export * from "./margin-line.vue?vue&type=script&lang=js"
import style0 from "./margin-line.vue?vue&type=style&index=0&id=1c6dfe1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6dfe1a",
  null
  
)

export default component.exports